// Wait for the page content to be fully loaded
document.addEventListener("DOMContentLoaded", function() {
  // Select all buttons with the 'data-cart-add' attribute
  const customCartButtons = document.querySelectorAll('[data-cart-add]');

  customCartButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Look for the closest parent container with product data
      const productContainer = button.closest('.product-item, .form-add-to-cart');

      if (productContainer) {
        let productData;
        let quantity = 1;

        // --- Case 1: The 'product-item' container (for home/collection pages) ---
        if (productContainer.dataset.productName) {
          productData = {
            id: productContainer.dataset.variantId,
            title: productContainer.dataset.productName,
            price: parseFloat(productContainer.dataset.productPrice),
            url: window.location.origin + productContainer.dataset.productUrl,
            image: 'https:' + productContainer.dataset.productImage
          };
        }
        // --- Case 2: The 'form-add-to-cart' container (for a single product page) ---
        else {
          const productPriceElement = productContainer.querySelector('.price');
          // FIX: Add the missing closing single quote here
          quantity = productContainer.querySelector('input[name="quantity"]').value;

          productData = {
            id: productContainer.querySelector('input[name="id"]').value,
            title: productContainer.querySelector('.product-title').innerText,
            price: parseFloat(productPriceElement.innerText.replace(/[^0-9.]/g, '')),
            url: window.location.href,
            image: productContainer.querySelector('.product-image').src
          };
        }

        // Call the theme's built-in Klaviyo function if it exists
        if (window.sendKlaviyoAddedToCart) {
          window.sendKlaviyoAddedToCart(productData, quantity);
        }
      }
    });
  });
});